/* ============================================================
   MIEL — theme behaviour (Vanilla JS, no dependencies)
   ------------------------------------------------------------
   1. Cart drawer on the Shopify AJAX Cart API
   2. Product card add-to-cart + Subscribe & Save toggle
   3. Honey Finder quiz (data from section-rendered JSON)
   4. Tasting Tour timeline (past-state, .ics download, reveal)
   5. Reveal-on-scroll + small account-page helpers
   ============================================================ */
(function () {
  "use strict";

  var config = window.MIEL || {};
  var S = config.strings || {};
  var routes = config.routes || {
    cart: "/cart",
    cartAdd: "/cart/add",
    cartChange: "/cart/change",
    checkout: "/checkout",
  };

  /* ---- helpers ---------------------------------------------- */
  function str(name, fallback) {
    return S[name] != null ? S[name] : fallback;
  }

  function fill(template, vars) {
    return template.replace(/\{\{\s*(\w+)\s*\}\}/g, function (match, key) {
      return vars[key] != null ? vars[key] : match;
    });
  }

  function el(tag, className, html) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (html != null) node.innerHTML = html;
    return node;
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    var format = config.moneyFormat || "€{{ amount }}";
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, Math.round(cents / 100).toString());
  }

  /* ---- cart API --------------------------------------------- */
  function getCart() {
    return fetch(routes.cart + ".js").then(function (r) { return r.json(); });
  }

  function addToCart(variantId, sellingPlanId, qty) {
    var item = { id: variantId, quantity: qty || 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;
    return fetch(routes.cartAdd + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [item] }),
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    });
  }

  function changeLine(key, quantity) {
    return fetch(routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    }).then(function (r) { return r.json(); });
  }

  /* ---- cart drawer ------------------------------------------ */
  var cartEls = {};
  var formaatMap = {};

  function updateCount(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (n) {
      n.textContent = cart.item_count;
      n.classList.toggle("is-empty", cart.item_count === 0);
    });
  }

  function renderCart(cart) {
    updateCount(cart);
    var body = cartEls.body;
    if (!body) return;
    body.innerHTML = "";

    if (!cart.items.length) {
      body.appendChild(el("p", "cart-drawer__empty", str("cartEmpty", "Een pot of twee verwijderd van iets lekkers.")));
      if (cartEls.foot) cartEls.foot.hidden = true;
      return;
    }
    if (cartEls.foot) cartEls.foot.hidden = false;

    var threshold = config.freeShippingCents || 0;
    if (threshold > 0) {
      var shipbar = el("div", "cart-shipbar");
      var rest = threshold - cart.total_price;
      shipbar.appendChild(el("p",
        "cart-shipbar__label" + (rest <= 0 ? " is-done" : ""),
        rest > 0
          ? fill(str("freeShippingRemaining", "Nog {{ amount }} tot gratis verzending"), { amount: formatMoney(rest) })
          : str("freeShippingReached", "Je bestelling wordt gratis verzonden ✓")));
      var track = el("div", "cart-shipbar__track");
      var fill = el("span", "cart-shipbar__fill");
      fill.style.width = Math.min(100, Math.round((cart.total_price / threshold) * 100)) + "%";
      track.appendChild(fill);
      shipbar.appendChild(track);
      body.appendChild(shipbar);
    }

    cart.items.forEach(function (item) {
      var line = el("div", "cart-line");

      var sw = el("div", "cart-line__swatch");
      if (item.image) {
        var im = el("img");
        im.src = item.image;
        im.alt = item.product_title;
        im.loading = "lazy";
        sw.appendChild(im);
      }
      line.appendChild(sw);

      var mid = el("div", "cart-line__mid");
      mid.appendChild(el("p", "cart-line__title", item.product_title));
      var handle = (item.url || "").split("?")[0].split("/").pop();
      if (formaatMap[handle]) {
        mid.appendChild(el("span", "cart-line__tag", formaatMap[handle]));
      }
      if (item.selling_plan_allocation) {
        mid.appendChild(
          el("span", "cart-line__tag", item.selling_plan_allocation.selling_plan.name)
        );
      }
      var qty = el("div", "cart-line__qty");
      var minus = el("button", null, "−");
      minus.type = "button";
      minus.setAttribute("aria-label", str("qtyDecrease", "Aantal verlagen"));
      minus.addEventListener("click", function () {
        changeLine(item.key, item.quantity - 1).then(renderCart);
      });
      var count = el("span", null, String(item.quantity));
      var plus = el("button", null, "+");
      plus.type = "button";
      plus.setAttribute("aria-label", str("qtyIncrease", "Aantal verhogen"));
      plus.addEventListener("click", function () {
        changeLine(item.key, item.quantity + 1).then(renderCart);
      });
      qty.appendChild(minus); qty.appendChild(count); qty.appendChild(plus);
      mid.appendChild(qty);
      line.appendChild(mid);

      var right = el("div", "cart-line__right");
      if (item.original_line_price !== item.final_line_price) {
        right.appendChild(el("s", "cart-line__was", formatMoney(item.original_line_price)));
      }
      right.appendChild(el("p", "cart-line__price", formatMoney(item.final_line_price)));
      var rm = el("button", "cart-line__remove", str("remove", "Verwijderen"));
      rm.type = "button";
      rm.addEventListener("click", function () {
        changeLine(item.key, 0).then(renderCart);
      });
      right.appendChild(rm);
      line.appendChild(right);

      body.appendChild(line);
    });

    if (cartEls.discounts) {
      cartEls.discounts.innerHTML = "";
      (cart.cart_level_discount_applications || []).forEach(function (d) {
        var row = el("div", "cart-drawer__discount");
        row.appendChild(el("span", null, fill(str("discount", "Korting ({{ title }})"), { title: d.title })));
        row.appendChild(el("span", null, "−" + formatMoney(d.total_allocated_amount)));
        cartEls.discounts.appendChild(row);
      });
    }
    if (cartEls.subtotal) cartEls.subtotal.textContent = formatMoney(cart.total_price);
  }

  function openCart() {
    if (!cartEls.drawer) return;
    cartEls.backdrop.hidden = false;
    void cartEls.backdrop.offsetWidth; // reflow so the transition fires
    cartEls.drawer.classList.add("is-open");
    cartEls.backdrop.classList.add("is-open");
    cartEls.drawer.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    if (cartEls.close) cartEls.close.focus();
  }

  function closeCart() {
    if (!cartEls.drawer || !cartEls.drawer.classList.contains("is-open")) return;
    cartEls.drawer.classList.remove("is-open");
    cartEls.backdrop.classList.remove("is-open");
    cartEls.drawer.setAttribute("aria-hidden", "true");
    document.body.style.overflow = "";
    setTimeout(function () {
      if (!cartEls.drawer.classList.contains("is-open")) cartEls.backdrop.hidden = true;
    }, 450);
  }

  function refreshCart() {
    return getCart().then(renderCart);
  }

  function initCart() {
    cartEls = {
      drawer: document.getElementById("cart-drawer"),
      backdrop: document.getElementById("cart-backdrop"),
      body: document.getElementById("cart-body"),
      foot: document.getElementById("cart-foot"),
      subtotal: document.getElementById("cart-subtotal"),
      discounts: document.getElementById("cart-discounts"),
      close: document.getElementById("cart-close"),
      checkout: document.getElementById("cart-checkout"),
      link: document.getElementById("cart-link"),
    };
    if (!cartEls.drawer) return;

    var mapEl = document.getElementById("cart-formaat-map");
    if (mapEl) {
      try { formaatMap = JSON.parse(mapEl.textContent); } catch (e) { formaatMap = {}; }
    }

    cartEls.close.addEventListener("click", closeCart);
    cartEls.backdrop.addEventListener("click", closeCart);
    if (cartEls.link) {
      cartEls.link.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
      });
    }
    cartEls.checkout.addEventListener("click", function () {
      cartEls.checkout.textContent = str("redirecting", "Doorsturen…");
      window.location.href = routes.checkout;
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeCart();
    });

    refreshCart();
  }

  /* ---- carousels (categorie-tegels, bestsellers) ----------------- */
  function initCarousels() {
    document.querySelectorAll("[data-carousel-nav]").forEach(function (nav) {
      var scroller = nav.parentElement.querySelector("[data-carousel]");
      if (!scroller) return;
      var vorige = nav.querySelector("[data-carousel-prev]");
      var volgende = nav.querySelector("[data-carousel-next]");

      function update() {
        var max = scroller.scrollWidth - scroller.clientWidth;
        nav.hidden = max < 20;
        vorige.disabled = scroller.scrollLeft < 10;
        volgende.disabled = scroller.scrollLeft > max - 10;
      }
      function step(richting) {
        var item = scroller.firstElementChild;
        var gap = parseFloat(getComputedStyle(scroller).columnGap) || 16;
        var breedte = item ? item.getBoundingClientRect().width + gap : scroller.clientWidth * 0.7;
        scroller.scrollBy({ left: richting * breedte, behavior: "smooth" });
      }
      vorige.addEventListener("click", function () { step(-1); });
      volgende.addEventListener("click", function () { step(1); });
      scroller.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---- welkomstbij --------------------------------------------- */
  function initWelcomeBee() {
    var root = document.getElementById("welcome-bee");
    if (!root) return;
    var KEY = "miel-welcome-seen";
    try { if (localStorage.getItem(KEY)) return; } catch (e) { return; }

    var bee = root.querySelector(".wbee__bee");
    var card = root.querySelector(".wbee__card");
    var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

    function markeer() { try { localStorage.setItem(KEY, "1"); } catch (e) {} }
    var landed = false;
    var finalPos = null;
    function land() {
      if (landed) return;
      landed = true;
      // failsafe-pad (rAF gethrotteld): zet de bij expliciet op de eindpositie,
      // anders blijft hij linksboven in beeld hangen
      if (finalPos) bee.style.transform = "translate(" + finalPos.x + "px," + finalPos.y + "px)";
      card.hidden = false;
      void card.offsetWidth;
      card.classList.add("is-open");
      bee.classList.add("is-landed");
      markeer();
    }

    setTimeout(function () {
      root.hidden = false;
      if (reduce) { bee.hidden = true; land(); return; }

      // vluchtpad: kubische bezier van rechts het scherm in, golvend
      // omlaag naar het kaartje linksonder
      var W = window.innerWidth, H = window.innerHeight;
      var p0 = { x: W + 50, y: H * 0.22 };
      var p1 = { x: W * 0.55, y: H * 0.04 };
      var p2 = { x: W * 0.32, y: H * 0.72 };
      var p3 = { x: 150, y: H - 235 };
      finalPos = p3;
      var t0 = null, DUR = 3400;

      function bez(t, a, b, c, d) {
        var u = 1 - t;
        return u * u * u * a + 3 * u * u * t * b + 3 * u * t * t * c + t * t * t * d;
      }
      bee.style.opacity = "1";
      function stap(ts) {
        if (landed) return;
        if (!t0) t0 = ts;
        var t = Math.min(1, (ts - t0) / DUR);
        var e = 1 - Math.pow(1 - t, 2.4); // uitdempende vaart
        var x = bez(e, p0.x, p1.x, p2.x, p3.x);
        var y = bez(e, p0.y, p1.y, p2.y, p3.y) + Math.sin(t * 24) * 7 * (1 - t);
        bee.style.transform = "translate(" + x + "px," + y + "px)";
        if (t < 1) requestAnimationFrame(stap);
        else land();
      }
      requestAnimationFrame(stap);
      // failsafe: als rAF gethrotteld wordt (tab op achtergrond),
      // verschijnt de kaart alsnog
      setTimeout(land, DUR + 1500);
    }, 3200);

    Array.prototype.forEach.call(root.querySelectorAll("[data-wbee-close]"), function (btn) {
      btn.addEventListener("click", function () {
        root.hidden = true;
        markeer();
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !root.hidden) { root.hidden = true; markeer(); }
    });

    var act = root.querySelector("[data-wbee-activate]");
    act.addEventListener("click", function () {
      markeer();
      act.disabled = true;
      act.textContent = str("loading", "Moment…");
      fetch(root.dataset.discountUrl)
        .then(function () {
          root.querySelector(".wbee__body").hidden = true;
          root.querySelector(".wbee__done").hidden = false;
          // bevestiging kort tonen, dan wegvliegen: het kaartje blijft
          // anders in beeld staan terwijl de korting al in de cart zit
          setTimeout(function () {
            card.classList.remove("is-open");
            bee.classList.add("is-gone");
            setTimeout(function () { root.hidden = true; }, 600);
          }, 2800);
        })
        .catch(function () {
          act.disabled = false;
          act.textContent = str("retry", "Probeer opnieuw");
        });
    });
  }

  /* ---- announcement bar --------------------------------------- */
  function initAnnouncement() {
    var msgs = document.querySelectorAll(".announcement__msg");
    if (msgs.length < 2) return;
    if (window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, 6000);
  }

  /* ---- mobile nav -------------------------------------------- */
  function initMobileNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var panel = document.getElementById("mobile-nav");
    if (!toggle || !panel) return;

    function open() {
      panel.hidden = false;
      void panel.offsetWidth; // reflow so the transition fires
      panel.classList.add("is-open");
      toggle.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
    }
    function close() {
      if (!panel.classList.contains("is-open")) return;
      panel.classList.remove("is-open");
      toggle.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      setTimeout(function () {
        if (!panel.classList.contains("is-open")) panel.hidden = true;
      }, 350);
    }

    toggle.addEventListener("click", function () {
      if (panel.classList.contains("is-open")) close();
      else open();
    });
    panel.addEventListener("click", function (e) {
      if (e.target.closest("a")) close();
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") close();
    });
  }

  /* ---- product page: gallery ---------------------------------- */
  function initGallery() {
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return null;
    var stage = gallery.querySelector("[data-gallery-stage]");
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    if (!stage || !thumbs.length) return null;

    function select(thumb) {
      stage.src = thumb.dataset.src;
      stage.srcset = thumb.dataset.srcset;
      var img = thumb.querySelector("img");
      stage.alt = img ? img.alt : "";
      thumbs.forEach(function (t) { t.classList.toggle("is-active", t === thumb); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener("click", function () { select(t); });
    });

    return {
      selectMedia: function (mediaId) {
        var match = thumbs.filter(function (t) {
          return t.dataset.mediaId === String(mediaId);
        })[0];
        if (match) select(match);
      },
    };
  }

  /* ---- product page: variant picker ---------------------------- */
  function initVariantPicker(gallery) {
    var picker = document.querySelector("[data-variant-picker]");
    var dataNode = document.querySelector("[data-variant-data]");
    if (!picker || !dataNode) return;

    var variants = [];
    try { variants = JSON.parse(dataNode.textContent); } catch (e) { return; }

    var form = picker.closest("form");
    var idInput = form.querySelector("[data-variant-id]");
    var priceEl = document.querySelector("[data-product-price]");
    var addBtn = form.querySelector("[data-add-button]");
    var radios = Array.prototype.slice.call(picker.querySelectorAll("input[type=radio]"));

    function selectedOptions() {
      var opts = [];
      radios.forEach(function (r) {
        if (r.checked) opts[parseInt(r.dataset.optionIndex, 10)] = r.value;
      });
      return opts;
    }

    function apply() {
      var opts = selectedOptions();
      var variant = variants.filter(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      })[0];

      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = str("unavailable", "Niet beschikbaar"); }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? str("addToCart", "In winkelwagen") : str("soldOut", "Uitverkocht");
      }
      if (gallery && variant.mediaId) gallery.selectMedia(variant.mediaId);
    }

    radios.forEach(function (r) { r.addEventListener("change", apply); });
  }

  /* ---- product page: AJAX add-to-cart --------------------------- */
  function initProductAjaxSubmit() {
    var form = document.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    var addBtn = form.querySelector("[data-add-button]");

    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var fd = new FormData(form);
      var planRaw = fd.get("selling_plan");
      var label = addBtn ? addBtn.textContent : "";

      if (addBtn) addBtn.disabled = true;
      addToCart(
        parseInt(fd.get("id"), 10),
        planRaw ? parseInt(planRaw, 10) : null,
        parseInt(fd.get("quantity"), 10) || 1
      )
        .then(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = str("added", "Toegevoegd ✓");
            setTimeout(function () { addBtn.textContent = label; }, 1400);
          }
          refreshCart().then(openCart);
        })
        .catch(function () {
          if (addBtn) {
            addBtn.disabled = false;
            addBtn.textContent = str("retry", "Probeer opnieuw");
          }
        });
    });
  }

  /* ---- shop filters ------------------------------------------ */
  var INTENSITY_LABELS = {
    light: str("intensityLight", "Zacht"),
    medium: str("intensityMedium", "In balans"),
    bold: str("intensityBold", "Vol & krachtig"),
  };
  var INTENSITY_ORDER = ["light", "medium", "bold"];

  function initShopFilters() {
    var bar = document.querySelector("[data-shop-filters]");
    var grid = document.querySelector("[data-shop-grid]");
    if (!bar || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-product-card]"));
    var emptyNote = document.querySelector("[data-filter-empty]");
    var countEl = bar.querySelector("[data-filter-count]");
    var active = { ptype: null, intensity: null, origin: null };

    function values(field) {
      var seen = {};
      cards.forEach(function (c) {
        var v = c.dataset[field];
        if (v) seen[v] = true;
      });
      var list = Object.keys(seen);
      if (field === "intensity") {
        list.sort(function (a, b) { return INTENSITY_ORDER.indexOf(a) - INTENSITY_ORDER.indexOf(b); });
      } else {
        list.sort();
      }
      return list;
    }

    var resets = Array.prototype.slice.call(document.querySelectorAll("[data-filter-reset]"));
    var footReset = bar.querySelector("[data-filter-reset]");
    var toggleLabel = document.querySelector("[data-filter-toggle-label]");
    var applyBtn = bar.querySelector("[data-filter-apply]");

    function syncGroup(wrap, field) {
      wrap.querySelectorAll(".shop-filters__chip").forEach(function (c) {
        var on = c.dataset.value === (active[field] || "");
        c.classList.toggle("is-active", on);
        c.setAttribute("aria-pressed", on ? "true" : "false");
      });
    }

    function apply() {
      var shown = 0;
      cards.forEach(function (c) {
        var visible = Object.keys(active).every(function (f) {
          return !active[f] || c.dataset[f] === active[f];
        });
        c.hidden = !visible;
        if (visible) shown++;
      });
      var filtered = !!(active.ptype || active.intensity || active.origin);
      if (emptyNote) emptyNote.hidden = shown > 0;
      if (footReset) footReset.hidden = !filtered;
      if (countEl) {
        countEl.textContent = filtered
          ? fill(str("filterCountFiltered", "{{ shown }} van {{ total }} producten"), { shown: shown, total: cards.length })
          : fill(str("filterCountAll", "{{ count }} producten"), { count: cards.length });
      }
      var activeCount = (active.ptype ? 1 : 0) + (active.intensity ? 1 : 0) + (active.origin ? 1 : 0);
      if (toggleLabel) toggleLabel.textContent = activeCount
        ? fill(str("filtersCount", "Filters ({{ count }})"), { count: activeCount })
        : str("filters", "Filters");
      if (applyBtn) {
        applyBtn.textContent = fill(
          shown === 1 ? str("showProductsOne", "Toon {{ count }} product") : str("showProductsOther", "Toon {{ count }} producten"),
          { count: shown }
        );
      }
    }

    function buildChip(wrap, field, value, label) {
      var chip = el("button", "shop-filters__chip", label);
      chip.type = "button";
      chip.dataset.value = value;
      chip.addEventListener("click", function () {
        active[field] = value || null;
        syncGroup(wrap, field);
        apply();
      });
      wrap.appendChild(chip);
    }

    var anyChips = false;
    Array.prototype.forEach.call(bar.querySelectorAll("[data-filter-group]"), function (group) {
      var field = group.dataset.filterGroup;
      var vals = values(field);
      if (vals.length < 2) { group.hidden = true; return; }
      anyChips = true;
      var wrap = group.querySelector(".shop-filters__chips");
      buildChip(wrap, field, "", str("filterAll", "Alle"));
      vals.forEach(function (v) {
        buildChip(wrap, field, v, field === "intensity" ? (INTENSITY_LABELS[v] || v) : v);
      });
      syncGroup(wrap, field);
    });

    resets.forEach(function (btn) {
      btn.addEventListener("click", function () {
        active = { ptype: null, intensity: null, origin: null };
        Array.prototype.forEach.call(bar.querySelectorAll("[data-filter-group]"), function (group) {
          syncGroup(group.querySelector(".shop-filters__chips"), group.dataset.filterGroup);
        });
        apply();
      });
    });

    /* mobiel: paneel schuift van links in (zelfde mechaniek als cart-drawer) */
    var openBtn = document.querySelector("[data-filters-open]");
    var backdrop = document.querySelector("[data-filters-backdrop]");
    function openFilters() {
      if (!backdrop) return;
      backdrop.hidden = false;
      void backdrop.offsetWidth; // reflow so the transition fires
      bar.classList.add("is-open");
      backdrop.classList.add("is-open");
      document.body.style.overflow = "hidden";
    }
    function closeFilters() {
      if (!bar.classList.contains("is-open")) return;
      bar.classList.remove("is-open");
      backdrop.classList.remove("is-open");
      document.body.style.overflow = "";
      setTimeout(function () {
        if (!bar.classList.contains("is-open")) backdrop.hidden = true;
      }, 450);
    }
    if (openBtn) openBtn.addEventListener("click", openFilters);
    if (backdrop) backdrop.addEventListener("click", closeFilters);
    Array.prototype.forEach.call(document.querySelectorAll("[data-filters-close]"), function (btn) {
      btn.addEventListener("click", closeFilters);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeFilters();
    });

    if (anyChips) {
      bar.hidden = false;
      apply();
    }
  }

  /* ---- shop sort ---------------------------------------------- */
  function initShopSort() {
    var select = document.querySelector("[data-shop-sort]");
    var grid = document.querySelector("[data-shop-grid]");
    if (!select || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll("[data-product-card]"));
    cards.forEach(function (c, i) { c.dataset.sortIndex = i; });

    select.addEventListener("change", function () {
      var mode = select.value;
      var sorted = cards.slice().sort(function (a, b) {
        if (mode === "price-asc") return a.dataset.price - b.dataset.price;
        if (mode === "price-desc") return b.dataset.price - a.dataset.price;
        if (mode === "title") {
          return a.querySelector(".product-card__title").textContent.trim()
            .localeCompare(b.querySelector(".product-card__title").textContent.trim(), document.documentElement.lang || "nl");
        }
        return a.dataset.sortIndex - b.dataset.sortIndex;
      });
      sorted.forEach(function (c) { grid.appendChild(c); });
    });
  }

  /* ---- product cards ---------------------------------------- */
  function initProductCards() {
    document.querySelectorAll("[data-product-card]").forEach(function (card) {
      var addBtn = card.querySelector("[data-add-to-cart]");
      var priceEl = card.querySelector("[data-card-price]");
      var variantId = parseInt(card.dataset.variantId, 10);
      var sellingPlanId = card.dataset.sellingPlanId
        ? parseInt(card.dataset.sellingPlanId, 10)
        : null;
      var mode = "onetime";

      var toggle = card.querySelector("[data-sub-toggle]");
      if (toggle) {
        var opts = toggle.querySelectorAll(".sub-toggle__opt");
        opts.forEach(function (opt) {
          opt.addEventListener("click", function () {
            mode = opt.dataset.mode;
            opts.forEach(function (o) {
              var on = o === opt;
              o.classList.toggle("is-active", on);
              o.setAttribute("aria-checked", on ? "true" : "false");
            });
            if (priceEl) {
              priceEl.textContent = formatMoney(
                parseInt(mode === "subscribe" ? card.dataset.subPrice : card.dataset.price, 10)
              );
            }
            if (addBtn && !addBtn.disabled) {
              addBtn.textContent = mode === "subscribe" ? str("subscribe", "Abonneer") : str("addToCart", "In winkelwagen");
            }
          });
        });
      }

      if (addBtn && !addBtn.disabled) {
        addBtn.addEventListener("click", function () {
          addToCart(variantId, mode === "subscribe" ? sellingPlanId : null, 1)
            .then(function () {
              addBtn.textContent = str("added", "Toegevoegd ✓");
              refreshCart().then(openCart);
              setTimeout(function () {
                addBtn.textContent = mode === "subscribe" ? str("subscribe", "Abonneer") : str("addToCart", "In winkelwagen");
              }, 1400);
            })
            .catch(function () {
              addBtn.textContent = str("retry", "Probeer opnieuw");
            });
        });
      }
    });
  }

  /* ---- Honey Finder quiz ------------------------------------- */
  var FINDER_STEPS = [
    {
      field: "purposes",
      question: str("finderQPurposes", "Waar ga je 'm voor gebruiken?"),
      options: [
        { value: "tea",      label: str("finderTea", "In thee & koffie"), hint: str("finderTeaHint", "een zachte zoetmaker") },
        { value: "bread",    label: str("finderBread", "Op brood & kaas"), hint: str("finderBreadHint", "smeuïg, vol van smaak") },
        { value: "health",   label: str("finderHealth", "Gezondheid & weerstand"), hint: str("finderHealthHint", "rauw & rijk aan enzymen") },
        { value: "skincare", label: str("finderSkincare", "Huidritueel"), hint: str("finderSkincareHint", "verzachtend & aromatisch") },
        { value: "gift",     label: str("finderGift", "Als cadeau"), hint: str("finderGiftHint", "om indruk te maken") },
      ],
    },
    {
      field: "intensity",
      question: str("finderQIntensity", "Hoe krachtig mag het zijn?"),
      options: [
        { value: "light",  label: str("finderLight", "Licht & delicaat"), hint: str("finderLightHint", "bloemig, subtiel") },
        { value: "medium", label: str("finderMedium", "In balans"), hint: str("finderMediumHint", "het gulden midden") },
        { value: "bold",   label: str("finderBold", "Vol & krachtig"), hint: str("finderBoldHint", "rijk, lang aanhoudend") },
      ],
    },
    {
      field: "flavours",
      question: str("finderQFlavours", "Welke smaaknoot spreekt je aan?"),
      options: [
        { value: "floral",   label: str("finderFloral", "Bloemig"), hint: str("finderFloralHint", "bloesem & weide") },
        { value: "herbal",   label: str("finderHerbal", "Kruidig"), hint: str("finderHerbalHint", "tijm & wilde kruiden") },
        { value: "malty",    label: str("finderMalty", "Moutig"), hint: str("finderMaltyHint", "diep & karamel") },
        { value: "aromatic", label: str("finderAromatic", "Aromatisch"), hint: str("finderAromaticHint", "geparfumeerd & zacht") },
      ],
    },
  ];

  var INTENSITY_RANK = { light: 0, medium: 1, bold: 2 };

  function scoreProduct(product, answers) {
    var score = 0;
    var reasons = [];

    if (answers.purposes && (product.purposes || []).indexOf(answers.purposes) !== -1) {
      score += 3;
      reasons.push(str("finderReasonPurpose", "jouw gebruiksdoel"));
    }
    if (answers.intensity && product.intensity) {
      var dist = Math.abs(INTENSITY_RANK[answers.intensity] - INTENSITY_RANK[product.intensity]);
      if (dist === 0) { score += 2; reasons.push(str("finderReasonIntensity", "de intensiteit die je zocht")); }
      else if (dist === 1) { score += 1; }
    }
    if (answers.flavours && (product.flavours || []).indexOf(answers.flavours) !== -1) {
      score += 2;
      reasons.push(str("finderReasonFlavour", "jouw smaaknoot"));
    }
    return { product: product, score: score, reasons: reasons };
  }

  function rankProducts(products, answers) {
    return products
      .map(function (p) { return scoreProduct(p, answers); })
      .sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        if (a.product.available !== b.product.available) {
          return a.product.available ? -1 : 1;
        }
        return a.product.priceCents - b.product.priceCents;
      });
  }

  function initFinder() {
    var stage = document.getElementById("finder-stage");
    var progressBar = document.getElementById("finder-progress-bar");
    var dataNode = document.querySelector("[data-finder-products]");
    if (!stage) return;

    var products = [];
    try {
      products = JSON.parse(dataNode ? dataNode.textContent : "[]");
    } catch (e) {
      products = [];
    }
    if (!products.length) {
      var section = stage.closest("section");
      if (section) section.hidden = true;
      return;
    }

    var state = { step: 0, answers: {} };

    function setProgress(fraction) {
      if (progressBar) progressBar.style.width = Math.round(fraction * 100) + "%";
    }

    function renderStep() {
      var step = FINDER_STEPS[state.step];
      var chosen = state.answers[step.field];

      setProgress(state.step / FINDER_STEPS.length);

      var wrap = el("div", "finder__step");
      wrap.appendChild(
        el("p", "finder__count", fill(str("finderStep", "Stap {{ step }} van {{ total }}"), { step: state.step + 1, total: FINDER_STEPS.length }))
      );
      wrap.appendChild(el("h3", "finder__question", step.question));

      var opts = el("div", "finder__options");
      step.options.forEach(function (opt) {
        var btn = el("button", "finder__option");
        btn.type = "button";
        if (chosen === opt.value) btn.classList.add("is-selected");
        btn.appendChild(el("span", "finder__option-label", opt.label));
        if (opt.hint) btn.appendChild(el("span", "finder__option-hint", opt.hint));
        btn.addEventListener("click", function () {
          state.answers[step.field] = opt.value;
          if (state.step < FINDER_STEPS.length - 1) {
            state.step += 1;
            renderStep();
          } else {
            renderResult();
          }
        });
        opts.appendChild(btn);
      });
      wrap.appendChild(opts);

      var nav = el("div", "finder__nav");
      var back = el("button", "finder__back", str("finderBack", "← Terug"));
      back.type = "button";
      if (state.step === 0) back.hidden = true;
      back.addEventListener("click", function () {
        state.step -= 1;
        renderStep();
      });
      nav.appendChild(back);
      wrap.appendChild(nav);

      stage.innerHTML = "";
      stage.appendChild(wrap);
    }

    function buildWhy(scored) {
      if (!scored.reasons.length) return str("finderBestMatch", "Onze beste match voor wat je zocht.");
      var seen = {}, unique = [];
      scored.reasons.forEach(function (r) {
        if (!seen[r]) { seen[r] = true; unique.push(r); }
      });
      var list = unique.length === 1
        ? unique[0]
        : unique.slice(0, -1).join(", ") + " " + str("finderAnd", "en") + " " + unique[unique.length - 1];
      return fill(str("finderChosenFor", "Gekozen om {{ reasons }}."), { reasons: list });
    }

    function renderResult() {
      setProgress(1);
      var ranked = rankProducts(products, state.answers);
      var hero = ranked[0];
      var alts = ranked.slice(1, 3);

      var wrap = el("div", "finder__result");
      wrap.appendChild(el("p", "finder__result-head", str("finderYourMatch", "Jouw match")));

      var match = el("div", "finder__match");
      var media = el("div", "finder__match-media");
      if (hero.product.image) {
        var img = el("img");
        img.src = hero.product.image;
        img.alt = hero.product.title;
        media.appendChild(img);
      }
      match.appendChild(media);

      var body = el("div", "finder__match-body");
      var titleLink = el("a", null);
      titleLink.href = hero.product.url;
      titleLink.appendChild(el("h3", "finder__match-title", hero.product.title));
      body.appendChild(titleLink);
      body.appendChild(el("p", "finder__match-why", buildWhy(hero)));
      var heroPriceEl = el("p", "finder__match-price", formatMoney(hero.product.priceCents));
      body.appendChild(heroPriceEl);

      var heroMode = "onetime";
      var cta = el("button", "btn btn--solid", hero.product.available ? str("addToCart", "In winkelwagen") : str("soldOut", "Uitverkocht"));
      cta.type = "button";

      if (hero.product.available && hero.product.subscription) {
        var toggle = el("div", "sub-toggle");
        var row = el("div", "sub-toggle__options");
        row.setAttribute("role", "radiogroup");
        row.setAttribute("aria-label", str("finderPurchaseOption", "Aankoopoptie"));
        [
          { mode: "onetime", title: str("finderOneTime", "Eenmalig"), meta: "&nbsp;" },
          { mode: "subscribe", title: str("finderSubscribeSave", "Abonneer & bespaar"), meta: hero.product.subscription.label },
        ].forEach(function (m) {
          var b = el("button", "sub-toggle__opt" + (m.mode === "onetime" ? " is-active" : ""));
          b.type = "button";
          b.setAttribute("role", "radio");
          b.setAttribute("aria-checked", m.mode === "onetime" ? "true" : "false");
          b.dataset.mode = m.mode;
          b.appendChild(el("span", "sub-toggle__opt-title", m.title));
          b.appendChild(el("span", "sub-toggle__opt-meta", m.meta));
          b.addEventListener("click", function () {
            heroMode = m.mode;
            row.querySelectorAll(".sub-toggle__opt").forEach(function (o) {
              var on = o === b;
              o.classList.toggle("is-active", on);
              o.setAttribute("aria-checked", on ? "true" : "false");
            });
            heroPriceEl.textContent = formatMoney(
              heroMode === "subscribe"
                ? hero.product.subscription.priceCents
                : hero.product.priceCents
            );
            cta.textContent = heroMode === "subscribe" ? str("subscribe", "Abonneer") : str("addToCart", "In winkelwagen");
          });
          row.appendChild(b);
        });
        toggle.appendChild(row);
        body.appendChild(toggle);
      }

      if (hero.product.available) {
        cta.addEventListener("click", function () {
          var planId = heroMode === "subscribe" && hero.product.subscription
            ? hero.product.subscription.sellingPlanId
            : null;
          addToCart(hero.product.variantId, planId, 1).then(function () {
            cta.textContent = heroMode === "subscribe" ? str("subscribed", "Geabonneerd ✓") : str("added", "Toegevoegd ✓");
            refreshCart().then(openCart);
          });
        });
      } else {
        cta.disabled = true;
      }
      body.appendChild(cta);
      match.appendChild(body);
      wrap.appendChild(match);

      if (alts.length) {
        var altsWrap = el("div", "finder__alts");
        altsWrap.appendChild(el("p", "finder__alts-label", str("finderAlsoLike", "Misschien vind je dit ook lekker")));
        var grid = el("div", "finder__alts-grid");
        alts.forEach(function (a) {
          var alt = el("div", "finder__alt");
          var link = el("a", "finder__alt-link");
          link.href = a.product.url;
          var sw = el("div", "finder__alt-swatch");
          if (a.product.image) {
            var ai = el("img");
            ai.src = a.product.image;
            ai.alt = a.product.title;
            sw.appendChild(ai);
          }
          link.appendChild(sw);
          var info = el("div", "finder__alt-info");
          info.appendChild(el("p", "finder__alt-title", a.product.title));
          if (a.product.subtitle) info.appendChild(el("p", "finder__alt-sub", a.product.subtitle));
          link.appendChild(info);
          alt.appendChild(link);

          var add = el("button", "finder__alt-add", a.product.available ? str("addToCart", "In winkelwagen") : str("soldOut", "Uitverkocht"));
          add.type = "button";
          if (a.product.available) {
            add.addEventListener("click", function () {
              addToCart(a.product.variantId, null, 1)
                .then(function () {
                  add.textContent = str("added", "Toegevoegd ✓");
                  refreshCart().then(openCart);
                  setTimeout(function () { add.textContent = str("addToCart", "In winkelwagen"); }, 1400);
                })
                .catch(function () { add.textContent = str("retry", "Probeer opnieuw"); });
            });
          } else {
            add.disabled = true;
          }
          alt.appendChild(add);
          grid.appendChild(alt);
        });
        altsWrap.appendChild(grid);
        wrap.appendChild(altsWrap);
      }

      var restart = el("button", "finder__restart", str("finderRestart", "↺ Opnieuw beginnen"));
      restart.type = "button";
      restart.addEventListener("click", function () {
        state = { step: 0, answers: {} };
        renderStep();
      });
      wrap.appendChild(restart);

      stage.innerHTML = "";
      stage.appendChild(wrap);
    }

    renderStep();
  }

  /* ---- Tasting Tour timeline --------------------------------- */
  function pad2(n) { return (n < 10 ? "0" : "") + n; }

  // an event is "past" only once its day is fully behind us (same-day = upcoming)
  function isPastDate(iso) {
    var d = String(iso).split("-");
    if (d.length !== 3) return false;
    var event = new Date(+d[0], +d[1] - 1, +d[2]);
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return event < today;
  }

  function icsEscape(s) {
    return String(s)
      .replace(/\\/g, "\\\\").replace(/;/g, "\\;")
      .replace(/,/g, "\\,").replace(/\n/g, "\\n");
  }

  // minimal, spec-valid all-day VEVENT (CRLF line endings required)
  function buildICS(stop) {
    var d = stop.date.split("-");
    var start = d[0] + d[1] + d[2];
    var endDate = new Date(+d[0], +d[1] - 1, +d[2] + 1);
    var end = endDate.getFullYear() + pad2(endDate.getMonth() + 1) + pad2(endDate.getDate());
    var now = new Date();
    var stamp = now.getUTCFullYear() + pad2(now.getUTCMonth() + 1) + pad2(now.getUTCDate()) +
      "T" + pad2(now.getUTCHours()) + pad2(now.getUTCMinutes()) + pad2(now.getUTCSeconds()) + "Z";
    var slug = (stop.city || "event").toLowerCase().replace(/[^a-z0-9]+/g, "-");
    var location = [stop.venue, stop.city].filter(Boolean).join(", ");
    return [
      "BEGIN:VCALENDAR",
      "VERSION:2.0",
      "PRODID:-//MIEL//Tasting Tour//EN",
      "CALSCALE:GREGORIAN",
      "BEGIN:VEVENT",
      "UID:miel-" + stop.date + "-" + slug + "@miel",
      "DTSTAMP:" + stamp,
      "DTSTART;VALUE=DATE:" + start,
      "DTEND;VALUE=DATE:" + end,
      "SUMMARY:" + icsEscape(fill(str("tourIcsSummary", "Proeverij By Amina's Honing · {{ city }}"), { city: stop.city || "" })),
      "LOCATION:" + icsEscape(location),
      "DESCRIPTION:" + icsEscape(fill(str("tourIcsDescription", "Proef onze honing: {{ honeys }}."), { honeys: stop.honeys })),
      "END:VEVENT",
      "END:VCALENDAR",
    ].join("\r\n");
  }

  function downloadICS(stop) {
    var blob = new Blob([buildICS(stop)], { type: "text/calendar;charset=utf-8" });
    var url = URL.createObjectURL(blob);
    var a = el("a");
    a.href = url;
    a.download = "miel-" + stop.date + "-" +
      (stop.city || "event").toLowerCase().replace(/[^a-z0-9]+/g, "-") + ".ics";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }

  function initTour() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(".tour-node"));
    if (!nodes.length) return;

    nodes.forEach(function (node, i) {
      var stop = {
        date: node.dataset.date,
        city: node.dataset.city,
        venue: node.dataset.venue,
        honeys: (node.dataset.honeys || "").split("|").join(", "),
      };
      var past = isPastDate(stop.date);
      var hint = node.querySelector("[data-tour-hint]");
      var cal = node.querySelector("[data-tour-cal]");

      if (past) {
        node.classList.add("is-past");
        if (hint) hint.textContent = str("tourPast", "Geweest");
      } else if (cal) {
        cal.hidden = false;
        cal.addEventListener("click", function () { downloadICS(stop); });
      }

      node.style.transitionDelay = Math.min(i, 6) * 0.08 + "s";

      // touch devices have no hover → tap toggles the card open/closed,
      // but taps on the card's own controls must not toggle the node
      node.addEventListener("click", function (e) {
        if (e.target.closest(".tour-node__card")) return;
        node.classList.toggle("is-active");
      });
    });

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---- reveal on scroll --------------------------------------- */
  function initReveal() {
    var targets = [".hero__content", ".section-head", ".product-grid", ".story__inner"];
    var nodes = [];
    targets.forEach(function (sel) {
      var n = document.querySelector(sel);
      if (n) { n.setAttribute("data-reveal", ""); nodes.push(n); }
    });

    if (!("IntersectionObserver" in window)) {
      nodes.forEach(function (n) { n.classList.add("is-visible"); });
      return;
    }
    // threshold 0: een percentage-drempel wordt bij hoge elementen (het
    // shop-grid is ~6500px) nooit gehaald en liet ze permanent op opacity 0
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -60px 0px" }
    );
    nodes.forEach(function (n) { io.observe(n); });
  }

  /* ---- product form: Subscribe & Save label state ------------- */
  function initProductForm() {
    document.querySelectorAll(".sub-toggle--form").forEach(function (fieldset) {
      var labels = fieldset.querySelectorAll(".sub-toggle__opt");
      // de grote prijs boven het formulier volgt de gekozen aankoopoptie
      var mainPrice = document.querySelector("[data-product-price]");
      function syncPrice() {
        if (!mainPrice || mainPrice.querySelector(".price-was")) return;
        var active = fieldset.querySelector(".sub-toggle__opt.is-active .sub-toggle__opt-price");
        if (active) mainPrice.textContent = active.textContent.trim();
      }
      function select(label) {
        var input = label.querySelector("input[type=radio]");
        if (!input) return;
        input.checked = true;
        input.dispatchEvent(new Event("change", { bubbles: true }));
        labels.forEach(function (l) { l.classList.toggle("is-active", l === label); });
        syncPrice();
      }
      labels.forEach(function (label) {
        label.addEventListener("click", function () { select(label); });
      });
      fieldset.querySelectorAll("[data-freq]").forEach(function (pill) {
        pill.addEventListener("click", function () {
          var label = pill.closest(".sub-toggle__opt");
          var input = label.querySelector("input[type=radio]");
          input.value = pill.dataset.freq;
          label.querySelectorAll("[data-freq]").forEach(function (p) {
            p.classList.toggle("is-current", p === pill);
          });
          var price = label.querySelector(".sub-toggle__opt-price");
          if (price && pill.dataset.price) price.textContent = pill.dataset.price;
          syncPrice();
        });
      });
    });
  }

  /* ---- account helpers ----------------------------------------- */
  function initAccountForms() {
    // login ↔ recover-password toggle
    var loginForm = document.querySelector("[data-login-form]");
    var recoverForm = document.querySelector("[data-recover-form]");
    if (loginForm && recoverForm) {
      document.querySelectorAll("[data-show-recover]").forEach(function (a) {
        a.addEventListener("click", function (e) {
          e.preventDefault();
          loginForm.hidden = true;
          recoverForm.hidden = false;
        });
      });
      document.querySelectorAll("[data-show-login]").forEach(function (a) {
        a.addEventListener("click", function (e) {
          e.preventDefault();
          recoverForm.hidden = true;
          loginForm.hidden = false;
        });
      });
      // deep link (#recover) and Shopify's reset-password redirect land here
      if (window.location.hash === "#recover") {
        loginForm.hidden = true;
        recoverForm.hidden = false;
      }
    }

    // addresses: show/hide new + edit forms, country defaults, delete confirm
    var newToggle = document.querySelector("[data-toggle-address-form]");
    var newForm = document.querySelector("[data-new-address-form]");
    if (newToggle && newForm) {
      newToggle.addEventListener("click", function () {
        newForm.hidden = !newForm.hidden;
      });
    }
    document.querySelectorAll("[data-edit-address]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var form = document.querySelector('[data-address-form="' + btn.dataset.editAddress + '"]');
        if (form) form.hidden = !form.hidden;
      });
    });
    document.querySelectorAll("select[data-default]").forEach(function (select) {
      if (select.dataset.default) select.value = select.dataset.default;
    });
    document.querySelectorAll("form[data-confirm]").forEach(function (form) {
      form.addEventListener("submit", function (e) {
        if (!window.confirm(form.dataset.confirm)) e.preventDefault();
      });
    });
  }

  /* ---- boot ---------------------------------------------------- */

  /* ---- sticky mobiele koopbalk (PDP) -------------------------- */
  function initStickyBuy() {
    var bar = document.querySelector('[data-sticky-buy]');
    var buyBtn = document.querySelector('[data-add-button]');
    if (!bar || !buyBtn || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var uitBeeld = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', uitBeeld);
      document.body.classList.toggle('has-stickybar', uitBeeld);
    });
    io.observe(buyBtn);
    var addBtn = bar.querySelector('[data-sticky-add]');
    if (addBtn) addBtn.addEventListener('click', function () { buyBtn.click(); });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initCart();
    initAnnouncement();
    initMobileNav();
    initShopFilters();
    initShopSort();
    initProductCards();
    initFinder();
    initTour();
    initReveal();
    initProductForm();
    initVariantPicker(initGallery());
    initProductAjaxSubmit();
    initStickyBuy();
    initAccountForms();
    initCarousels();
    initWelcomeBee();
  });
})();
